import { useParams } from "react-router-dom";
import useReviewersActions from "./useReviewersActions";
import { useEffect, useState } from "react";

export default function useReviewer() {
    const { reviewer_id } = useParams();
    const { getReviewer } = useReviewersActions();
    const [reviewer, setReviewer] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    async function fetchReviewer() {
        try {
            setIsLoading(true);
            const data = await getReviewer(reviewer_id); 
            setReviewer(data);
        } catch (error) {
            throw error
        } finally {
            setIsLoading(false); 
        }
    }

    useEffect(() => {
        fetchReviewer();
    }, [reviewer_id]);

    return { reviewer, isLoading };
}
